"use client"

import { create } from "zustand"
import { persist } from "zustand/middleware"

export interface UserSettings {
  fullName: string
  email: string
  username: string
  phoneNumber: string
  bio: string
  profileImage?: string
  notifications: {
    emailNotifications: boolean
    taskReminders: boolean
    classUpdates: boolean
    performanceAlerts: boolean
  }
  permissions: string[]
}

interface UserSettingsStore {
  settings: UserSettings
  updateSettings: (newSettings: Partial<UserSettings>) => void
  updateNotifications: (notifications: Partial<UserSettings["notifications"]>) => void
  updatePermissions: (permissions: string[]) => void
  resetSettings: () => void
}

const DEFAULT_SETTINGS: UserSettings = {
  fullName: "Michael Okafor",
  email: "mikeofor@gmail.com",
  username: "mikeofor",
  phoneNumber: "+234 812-345-6789",
  bio: "",
  profileImage: "/profile-avatar.png",
  notifications: {
    emailNotifications: true,
    taskReminders: true,
    classUpdates: true,
    performanceAlerts: true,
  },
  permissions: ["view_student_data", "edit_grades", "manage_classes"],
}

export const useUserSettingsStore = create<UserSettingsStore>()(
  persist(
    (set) => ({
      settings: DEFAULT_SETTINGS,
      updateSettings: (newSettings) =>
        set((state) => ({
          settings: { ...state.settings, ...newSettings },
        })),
      updateNotifications: (notifications) =>
        set((state) => ({
          settings: {
            ...state.settings,
            notifications: {
              ...state.settings.notifications,
              ...notifications,
            },
          },
        })),
      updatePermissions: (permissions) =>
        set((state) => ({
          settings: {
            ...state.settings,
            permissions,
          },
        })),
      resetSettings: () =>
        set({
          settings: DEFAULT_SETTINGS,
        }),
    }),
    {
      name: "user-settings-storage",
    },
  ),
)
